import { render } from "./squeue_checkboxes.vue?vue&type=template&id=6a1850a9&lang=pug"
import script from "./squeue_checkboxes.vue?vue&type=script&lang=js"
export * from "./squeue_checkboxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__